import { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
	Box,
	Container,
	Divider,
	Typography,
	Tooltip,
	IconButton,
	Button,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import InventoryIcon from "@mui/icons-material/Inventory";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PaymentIcon from "@mui/icons-material/Payment";
import LogoutIcon from "@mui/icons-material/Logout";
import DownloadIcon from "@mui/icons-material/Download";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useAuth } from "../../context/Auth/AuthContext";
import { useCart } from "../../context/Cart/CartContext";
import OrderItem from "../../components/OrderItem/OrderItem";
import UserConfig from "../../components/UserConfig";
import { api } from "../../services/api";

const config = [
	{
		startIcon: <AppRegistrationIcon />,
		endIcon: <ArrowForwardIosIcon />,
		title: "Mis Datos",
		href: "/user-account/data",
	},
	{
		startIcon: <LockOutlinedIcon />,
		endIcon: <ArrowForwardIosIcon />,
		title: "Cambio de Contraseña",
		href: "/user-account/password-change",
	},
	{
		startIcon: <LocationOnIcon />,
		endIcon: <ArrowForwardIosIcon />,
		title: "Direcciones y formas de envío",
		href: "/user-account/address-shipping",
	},
	{
		startIcon: <PaymentIcon />,
		endIcon: <ArrowForwardIosIcon />,
		title: "Formas de pago",
		href: "/user-account/pay-methods",
	},
];

const MyAccountContainer = () => {
	const [orders, setOrders] = useState();
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const { signOut, userData } = useAuth();
	const { cart } = useCart();

	const redirectOrder = (id) => {
		navigate(`/user-account/orders/${id}`);
	};

	const handleReturn = () => {
		if (pathname === "/user-account") {
			navigate("/");
		} else {
			navigate(-1);
		}
	};

	function downloadPriceList() {
		api.export
			.listPrices(userData.clientPriceListId)
			.then((response) => {
				const filename = response.headers
					.get("Content-Disposition")
					.split("filename=")[1];
				response.blob().then((blob) => {
					const url = window.URL.createObjectURL(new Blob([blob]));
					const link = document.createElement("a");
					link.href = url;
					link.download = filename;
					document.body.appendChild(link);
					link.click();
					link.parentNode.removeChild(link);
				});
			})
			.catch((error) => {
				console.log("Error al obtener lista de precios", error.message);
			});
	}

	useEffect(() => {
		api.orders
			.getLatestOrders(userData.clientId)
			.then((response) => response.json())
			.catch((err) => console.log(err))
			.then((ordersAPI) => setOrders(ordersAPI))
			.catch((err) => console.log(err));
	}, [userData]);

	return (
		<Fragment>
			<Container>
				<Box display="flex" alignItems="center" minHeight="56px">
					<Box
						display="flex"
						alignItems="center"
						minHeight="56px"
						onClick={handleReturn}
					>
						<Tooltip title="Volver">
							<IconButton
								size="large"
								aria-label="volver"
								aria-controls="volver-carrito"
								aria-haspopup="false"
								color="inherit"
							>
								<ArrowBackIosNewIcon />
							</IconButton>
						</Tooltip>
						<Typography
							variant="subtitle2"
							color="initial"
							style={{ cursor: "pointer" }}
						>
							Volver a home
						</Typography>
					</Box>
					<Typography
						variant="h5"
						display="flex"
						justifyContent="center"
						alignItems="center"
						flexGrow={1}
					>
						Mi cuenta
					</Typography>
					<Box>
						<Tooltip title="Carrito">
							<Link to="/cart">
								<IconButton
									size="large"
									aria-label="carrito"
									aria-controls="logo-carrito"
									aria-haspopup="false"
									color="inherit"
								>
									{cart?.length > 0 ? (
										<ShoppingCartIcon color="secondary" />
									) : (
										<ShoppingCartOutlinedIcon color="secondary" />
									)}
								</IconButton>
							</Link>
						</Tooltip>
					</Box>
				</Box>
			</Container>
			<Divider />
			<Container>
				<Box display="flex" alignItems="center" justifyContent="space-between">
					<Box display="flex" flexDirection="column">
						<Typography
							variant="h6"
							display="flex"
							justifyContent="flex-start"
							alignItems="center"
							flexGrow={1}
							mt={2}
							sx={{ fontWeight: "600" }}
						>
							¡Hola, {userData.userName}!
						</Typography>
						<Typography
							variant="subtitle1"
							mb={3}
							sx={{ color: (theme) => theme.palette.light.main }}
						>
							Conocé el estado de tu cuenta
						</Typography>
					</Box>
					<Box display="flex" alignItems="center">
						<Typography
							variant="body1"
							display="flex"
							justifyContent="flex-start"
							alignItems="center"
							ml={2}
							flexGrow={1}
							sx={{ fontWeight: "600" }}
						>
							<Button
								variant="contained"
								style={{ background: "#e9ecef" }}
								size="small"
								onClick={() => downloadPriceList()}
							>
								<DownloadIcon fontSize="small" style={{ marginRight: 4 }} />
								Descargar Lista de Precios
							</Button>
						</Typography>
					</Box>
				</Box>
				<Box display="flex" alignItems="center">
					<InventoryIcon fontSize="small" />
					<Typography
						variant="body1"
						display="flex"
						justifyContent="flex-start"
						alignItems="center"
						ml={2}
						flexGrow={1}
						sx={{ fontWeight: "600" }}
					>
						Pedidos Pendientes
					</Typography>
					<Link to="/user-account/orders/pending" className="config-items">
						<Button color="secondary" sx={{ textTransform: "none" }}>
							Ver todos los pedidos
						</Button>
					</Link>
				</Box>
				<Divider />
				{orders?.length === 0 ? (
					<Box
						sx={{
							minHeight: "25vh",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Typography variant="h2" sx={{ color: "#5E5E5E" }}>
							No tiene pedidos pendientes
						</Typography>
					</Box>
				) : (
					orders?.slice(0, 4).map((order) => {
						return (
							<Fragment key={order.idOrder}>
								<Button
									sx={{ textTransform: "none" }}
									color="secondary"
									fullWidth
									onClick={() => redirectOrder(order.idOrder)}
								>
									<OrderItem
										orderDate={order.orderDate}
										state={order.state}
										orderItems={order.orderItems}
										withdrawalPoint={order.withdrawalPoint}
										isPaid={order.isPaid}
									/>
								</Button>
								<Divider />
							</Fragment>
						);
					})
				)}

				{/******  Pendiente para otra etapa ******/}
				{/* <Box display="flex" justifyContent="center" mt={4}>
					<Button
						variant="contained"
						color="primary"
						sx={{
							fontSize: "1rem",
							fontWeight: "400",
							border: "1px solid #292929",
							width: "50%",
							padding: "0.5rem",
							textTransform: "capitalize",
						}}
						disableElevation
					>
						Asociar envíos
					</Button>
				</Box> 
				<Box display="flex" mt={5}>
					<CreditCardIcon fontSize="small" />
					<Typography
						variant="body1"
						display="flex"
						justifyContent="flex-start"
						alignItems="center"
						flexGrow={1}
						mb={2}
						ml={2}
						sx={{ fontWeight: "600" }}
					>
						Saldo de tu cuenta
					</Typography>
				</Box>
				<Divider />
				<Box display="flex" justifyContent="space-between" my={2}>
					<Typography
						variant="subtitle2"
						sx={{
							fontSize: "1rem",
						}}
					>
						Saldo a pagar
					</Typography>
					<Typography
						variant="subtitle2"
						textAlign="right"
						sx={{
							fontSize: "1rem",
						}}
					>
						{formatter.format(user.debit)}
					</Typography>
				</Box>
				
				<Divider />
				<Box display="flex" justifyContent="space-between" my={2}>
					<Typography
						variant="subtitle2"
						sx={{
							fontSize: "1rem",
						}}
					>
						Saldo a favor
					</Typography>
					<Typography
						variant="subtitle2"
						textAlign="right"
						sx={{
							fontSize: "1rem",
						}}
					>
						{formatter.format(user.credit)}
					</Typography>
				</Box>
				*/}

				<Typography
					variant="h6"
					display="flex"
					justifyContent="flex-start"
					alignItems="center"
					flexGrow={1}
					mt={5}
					mb={1}
					sx={{ fontWeight: "600" }}
				>
					Mi Configuración
				</Typography>
			</Container>
			<Container>
				<Divider />

				{config.map((el, index) => {
					return (
						<UserConfig
							key={index}
							startIcon={el.startIcon}
							endIcon={el.endIcon}
							title={el.title}
							href={el.href}
						/>
					);
				})}

				<Button
					color="secondary"
					startIcon={<LogoutIcon />}
					fullWidth
					sx={{ textTransform: "none", padding: "1rem" }}
					onClick={signOut}
				>
					<Typography
						variant="body1"
						display="flex"
						justifyContent="flex-start"
						alignItems="center"
						flexGrow={1}
						sx={{ fontWeight: "600" }}
					>
						Cerrar Sesión
					</Typography>
				</Button>

				<Divider sx={{ marginBottom: "1rem" }} />
			</Container>
		</Fragment>
	);
};

export default MyAccountContainer;
